import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 4a1 1 0 0 1 1 1v6h6a1 1 0 0 1 0 2h-6v6a1 1 0 0 1 -2 0v-6h-6a1 1 0 0 1 0 -2h6v-6a1 1 0 0 1 1 -1","key":"svg-0"}]]

const IconPlusFilled = createReactComponent('filled', 'plus-filled', 'PlusFilled', __iconNode);

export default IconPlusFilled;